import { render, staticRenderFns } from "./MarketPage.vue?vue&type=template&id=bbf450fe&scoped=true"
import script from "./MarketPage.vue?vue&type=script&lang=js"
export * from "./MarketPage.vue?vue&type=script&lang=js"
import style0 from "./MarketPage.vue?vue&type=style&index=0&id=bbf450fe&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bbf450fe",
  null
  
)

export default component.exports